export function isSameType<U>(a: U, b: any): b is U {
  return typeof a === typeof b;
}
